module.exports = __webpack_public_path__ + "img/caption.8b98402c.png";